/*
  DOC — automatic free-gift cart enforcement.
  Keeps exactly one FREE GIFT line item (variant 60731049017678) in the cart
  whenever any other product is present, removes it when the cart would
  otherwise be empty, and clamps its quantity back to 1 if anything tries to
  change it. Exposed as window.DocFreeGift so the PDP add-to-cart button can
  add the main item + gift together and open the cart drawer in one flow.
*/
(function () {
  var GIFT_VARIANT_ID = 60731049017678;
  var queue = Promise.resolve();

  function jsonFetch(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json();
    });
  }

  // Reconciles the cart against the "exactly one gift, only when the cart
  // isn't otherwise empty" rule. Resolves with true if a change was made.
  function reconcile() {
    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var giftLine = null;
        var otherQty = 0;
        cart.items.forEach(function (item) {
          if (item.variant_id === GIFT_VARIANT_ID) {
            giftLine = item;
          } else {
            otherQty += item.quantity;
          }
        });

        if (otherQty === 0) {
          if (giftLine) {
            return jsonFetch('/cart/change.js', { id: String(GIFT_VARIANT_ID), quantity: 0 }).then(function () { return true; });
          }
          return false;
        }

        if (!giftLine) {
          return jsonFetch('/cart/add.js', { items: [{ id: GIFT_VARIANT_ID, quantity: 1 }] }).then(function () { return true; });
        }

        if (giftLine.quantity !== 1) {
          return jsonFetch('/cart/change.js', { id: String(GIFT_VARIANT_ID), quantity: 1 }).then(function () { return true; });
        }

        return false;
      })
      .catch(function (err) {
        console.error('DOC free gift enforcement failed', err);
        return false;
      });
  }

  // Serializes reconcile() calls so overlapping cart mutations can't race.
  function reconcileQueued() {
    queue = queue.then(reconcile);
    return queue;
  }

  function getSectionHTML(id) {
    return fetch('/cart?section_id=' + id).then(function (res) { return res.text(); });
  }

  // Quiet refresh: updates drawer + cart-page DOM in place without forcing
  // the drawer open. Used for background self-healing.
  function refreshQuiet() {
    var ids = ['cart-drawer', 'cart-icon-bubble'];
    if (document.getElementById('main-cart-items')) ids.push('main-cart-items');
    if (document.getElementById('main-cart-footer')) ids.push('main-cart-footer');

    Promise.all(ids.map(function (id) { return getSectionHTML(id).then(function (html) { return { id: id, html: html }; }); }))
      .then(function (results) {
        results.forEach(function (r) {
          var doc = new DOMParser().parseFromString(r.html, 'text/html');
          if (r.id === 'cart-drawer') {
            var target = document.getElementById('CartDrawer');
            var source = doc.getElementById('CartDrawer');
            if (target && source) target.innerHTML = source.innerHTML;
          } else if (r.id === 'main-cart-items' || r.id === 'main-cart-footer') {
            var el = document.getElementById(r.id);
            var srcEl = doc.getElementById(r.id);
            if (el && srcEl) el.querySelector('.js-contents') && srcEl.querySelector('.js-contents') && (el.querySelector('.js-contents').innerHTML = srcEl.querySelector('.js-contents').innerHTML);
          } else {
            var bubble = document.getElementById(r.id);
            var srcBubble = doc.querySelector('.shopify-section');
            if (bubble && srcBubble) bubble.innerHTML = srcBubble.innerHTML;
          }
        });
      })
      .catch(function (err) { console.error('DOC free gift section refresh failed', err); });
  }

  // Loud refresh: rebuilds the drawer sections and opens it. Used right
  // after a PDP add-to-cart.
  function refreshAndOpenDrawer() {
    var ids = ['cart-drawer', 'cart-icon-bubble'];
    Promise.all(ids.map(function (id) { return getSectionHTML(id).then(function (html) { return { id: id, html: html }; }); }))
      .then(function (results) {
        var sections = {};
        results.forEach(function (r) { sections[r.id] = r.html; });
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents({ sections: sections });
        }
      })
      .catch(function (err) { console.error('DOC free gift drawer refresh failed', err); });
  }

  // Adds the given line item(s) to the cart, enforces the gift rule, then
  // opens the drawer showing both. `items` is an array of
  // { id, quantity, selling_plan? } objects for the real product(s).
  function addAndOpen(items) {
    return jsonFetch('/cart/add.js', { items: items })
      .then(function (data) {
        if (data.status) throw new Error(data.description || 'Add to cart failed');
        return reconcileQueued();
      })
      .then(function () {
        refreshAndOpenDrawer();
      });
  }

  // Adds the given line item(s) to the cart, enforces the gift rule quietly
  // (no drawer), then redirects straight to checkout. Used when the PDP
  // offer should skip the cart drawer entirely.
  function addAndRedirect(items, redirectUrl) {
    return jsonFetch('/cart/add.js', { items: items })
      .then(function (data) {
        if (data.status) throw new Error(data.description || 'Add to cart failed');
        return reconcileQueued();
      })
      .then(function () {
        window.location.href = redirectUrl || '/checkout';
      });
  }

  window.DocFreeGift = {
    GIFT_VARIANT_ID: GIFT_VARIANT_ID,
    ensure: reconcileQueued,
    addAndOpen: addAndOpen,
    addAndRedirect: addAndRedirect
  };

  function boot() {
    // Defensive pass on page load (bookmarked /cart, stale sessions, etc).
    reconcileQueued().then(function (changed) {
      if (changed) refreshQuiet();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        reconcileQueued().then(function (changed) {
          if (changed) refreshQuiet();
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
